import React from "react";
import "./Quarter.css";

const Quarter = ({
  value = "35",
  quarter = "Quarter 1",
  width = "120px",
  height = "80px",
  color = "",
  onClick = null,
  isLarge = false,
}) => {
  const getColorGradient = (color) => {
    // Helper function to darken a color
    const darkenColor = (hex, percent) => {
      // Remove # if present
      hex = hex.replace("#", "");

      // Convert to RGB
      const r = parseInt(hex.substr(0, 2), 16);
      const g = parseInt(hex.substr(2, 2), 16);
      const b = parseInt(hex.substr(4, 2), 16);

      // Darken by reducing each RGB value
      const darkenedR = Math.floor(r * (1 - percent / 100));
      const darkenedG = Math.floor(g * (1 - percent / 100));
      const darkenedB = Math.floor(b * (1 - percent / 100));

      // Convert back to hex
      const toHex = (n) => {
        const hex = n.toString(16);
        return hex.length === 1 ? "0" + hex : hex;
      };

      return `#${toHex(darkenedR)}${toHex(darkenedG)}${toHex(darkenedB)}`;
    };

    // Generate gradient from the provided color to a darker version
    const darkerColor = darkenColor(color, 30); // Darken by 30%
    return `linear-gradient(180deg, ${color} 0%, ${darkerColor} 100%)`;
  };

  const cardStyle = {
    width: width,
    height: height,
    background: getColorGradient(color),
  };

  const valueStyle = {
    fontSize: isLarge ? "80px" : "32px",
    lineHeight: isLarge ? "60px" : "22px",
  };

  const labelStyle = {
    fontSize: isLarge ? "24px" : "16px",
    lineHeight: isLarge ? "30px" : "22px",
  };

  return (
    <div className="quarter-container">
      <div className="quarter-card" style={cardStyle}>
        <div
          className="quarter-label"
          onClick={onClick}
          style={{
            cursor: onClick ? "pointer" : "default",
            ...labelStyle,
          }}>
          {quarter}
        </div>
        <p style={valueStyle}>{value}</p>
      </div>
    </div>
  );
};

export default Quarter;
